import AlertsTable from '../../features/procedureEvent';

import Button from '../Assets/Button';

import { useAppDispatch } from '../../App/redux/store';
import { modalsActions } from '../../features/modals/modalsSlice';
import './styles/procedureEventModal.scss';

const ProcedureEventsModal = () => {
  const dispatch = useAppDispatch();
  return (
    <div className="procedure-event-modal">
      <AlertsTable />
      <div className="procedure-event-modal-btn-container">
        <Button
          btnType="button"
          btnContent="FERMER"
          primary
          handleClick={() => dispatch(modalsActions.notificationBell(false))}
        />
      </div>
    </div>
  );
};

export default ProcedureEventsModal;
